export default __webpack_public_path__ + "9932fb2d.png";